module.exports = __webpack_public_path__ + "media/images/emoticons/sad-2f4401093f00e8028e2648f56d0f1c14.gif";